module.exports = __webpack_public_path__ + "img/pic_bg01.12f47397.png";